
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import {getFirestore} from "firebase/firestore"


const firebaseConfig = {
  apiKey: "AIzaSyAaAUIB2Ehvr4n7tpOysh201aN_KKGdltQ",
  authDomain: "mychat-71515.firebaseapp.com",
  projectId: "mychat-71515",
  storageBucket: "mychat-71515.appspot.com",
  messagingSenderId: "707783384028",
  appId: "1:707783384028:web:bdf59f3699c470ec688d19"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth=getAuth();
export const storage=getStorage();
export const db=getFirestore();